import * as yup from "yup";
import { PHONE_NO_REGEX } from "../utils/ValidationRules";

export default yup.string().matches(PHONE_NO_REGEX, {
	message: "PHONE_NO_NOT_VALID",
	excludeEmptyString: true,
});
